import { api } from './api'

export interface MonitorOverview {
  generated_at: string
  signals_today_makatsu: number
  dispatch_attempts_today: number
  executions_today: number
  executions_today_all: number
  execution_rate_pct: number | null
  skips_today: number
  open_operations: number
  ea_prop: { online: number; total: number }
  ea_broker: { online: number; total: number }
}

export interface MonitorExecRow {
  signal_id: number
  pair_id: number
  user: string | null
  email: string | null
  provider: string | null
  direction: string
  status: string
  created_at: string | null
  executed_at: string | null
  prop_entry_price: number | null
  notes: string | null
}

export interface MonitorSkipRow {
  pair_id: number | null
  user: string | null
  email: string | null
  reason: string
  stage?: string | null
}

export interface MonitorSignal {
  key: string
  source: string
  engine: string
  created_at: string | null
  direction: string | null
  entry_price: number | null
  zone_low: number | null
  zone_high: number | null
  status: string | null
  executed: MonitorExecRow[]
  skipped: MonitorSkipRow[]
  executed_count: number
  attempted_count: number
  skipped_count: number
}

export interface MonitorPair {
  pair_id: number
  display_name: string | null
  user: string
  email: string
  user_id: number
  provider: string
  phase: string | null
  control_mode: boolean
  makatsu_enabled: boolean
  prop_online: boolean
  prop_last_seen_s: number | null
  prop_trade_allowed: boolean | null
  prop_not_ready: string | null
  broker_online: boolean
  broker_last_seen_s: number | null
  status: 'ONLINE' | 'PARTIAL' | 'OFFLINE'
}

export interface MonitorPosition {
  operation_id: number
  pair_id: number
  user: string | null
  email: string | null
  provider: string | null
  direction: string
  status: string
  source: string | null
  engine: string | null
  prop_open_price: number | null
  prop_lots: number | null
  broker_lots: number | null
  sl_usd: number | null
  tp_usd: number | null
  shield_phase: string | null
  created_at: string | null
}

export interface MonitorUser {
  user_id: number
  email: string
  name: string
  active_pairs: number
  dispatches_today: number
  executed_today: number
  last_execution: string | null
}

export interface MonitorHistoryRow {
  type: 'dispatch' | 'skip'
  at: string | null
  engine: string
  pair_id: number | null
  provider: string | null
  direction: string | null
  status: string
  executed_at: string | null
  entry_price: number | null
  detail: string | null
}

export interface MonitorUserHistory {
  user: { id: number; email: string; name: string }
  days: number
  history: MonitorHistoryRow[]
  operations: {
    operation_id: number
    pair_id: number
    provider: string | null
    direction: string
    status: string
    engine: string | null
    open_price: number | null
    close_price: number | null
    pnl: number | null
    close_reason: string | null
    created_at: string | null
    closed_at: string | null
  }[]
}

export const adminMonitorService = {
  getOverview: () => api.silent.get<MonitorOverview>('/admin/monitor/overview'),
  getSignals: (hours = 24) =>
    api.silent.get<{ hours: number; signals: MonitorSignal[] }>(`/admin/monitor/signals?hours=${hours}`),
  getPairs: () => api.silent.get<{ pairs: MonitorPair[] }>('/admin/monitor/pairs'),
  getPositions: () => api.silent.get<{ positions: MonitorPosition[] }>('/admin/monitor/positions'),
  getUsers: () => api.silent.get<{ users: MonitorUser[] }>('/admin/monitor/users'),
  getUserHistory: (userId: number, days = 7) =>
    api.silent.get<MonitorUserHistory>(`/admin/monitor/users/${userId}/history?days=${days}`),
}
